import { RouteConfig } from "vue-router";
import CookieDisabled from "@/views/Errors/CookieDisabled.vue";
import UserList from '@/views/User/UserList.vue';
import UserForm from '@/views/User/UserForm.vue';
import TenantList from '@/views/Tenant/TenantList.vue';
import RoleList from '@/views/Role/RoleList.vue';
import PartnerAgenciesList from "@/views/Partner/PartnerAgenciesList.vue";


const prefix = '/chat'
const chatRoutes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'chat-index',
        component: () => import("@/views/Chat/ChatIndex.vue"),
        props: (route:any) => ({
            ...route.query,
          })
    },
    {
        path: '/escalations',
        name: 'chat-escalations',
        component: () => import("@/views/Chat/Escalations.vue"),
    },
]
chatRoutes.forEach((route) => {
    route.path = prefix + route.path
})
export default chatRoutes;
